export enum CodeCheckStatus {
  CHECK_STATUS_PROCESSING = 1,
  CHECK_STATUS_ACCEPTED = 2,
  CHECK_STATUS_REJECTED = 3,
  CHECK_STATUS_ERROR = 4,
  CHECK_STATUS_FINISHED = 5,
  CHECK_STATUS_PREPARING = 6,
  CHECK_STATUS_CANCELED = 7
}
